<template>
  <div class="main-content">
    <SectionTitle class="animate-target" v-animate-in :title="title"></SectionTitle>
    <div class="ctn-text">
      <p class="animate-target" v-animate-in>Combination of finerenone with simultaneous initiation of finerenone and SGLT2i</p>
      <p class="animate-target" v-animate-in>People saw an initial eGFR decline at 2 weeks<sup>1</sup>​</p>
      <p class="animate-target" v-animate-in>eGFR levels returned to baseline after end of treatment</p>
    </div>
    <div ref="target" class="show_animation animate-target" v-animate-in>
      <img src="../../assets/images/p3-12/chart-top.svg" />
      <img src="../../assets/images/p3-12/line-top.svg" />
      <img src="../../assets/images/p3-12/num-top.svg" />
    </div>
    <div class="ctn-text2 animate-target" v-animate-in><p>The incidence of acute kidney injury was low in the combination therapy group (1.9%), with no serious events of acute kidney injury reported.<sup>1</sup></p></div>
    <div class="ctn-text">
      <p class="animate-target" v-animate-in>Combination of finerenone with simultaneous initiation of finerenone and SGLT2i</p>
      <p class="animate-target" v-animate-in>People achieved an additive reduction in SBP compared with either agent alone<sup>*1</sup></p>
      <p class="animate-target" v-animate-in>SBP returned to baseline after end of treatment</p>
    </div>
    <div ref="target2" class="show_animation animate-target" v-animate-in>
      <img src="../../assets/images/p3-12/chart-bottom.svg" />
      <img src="../../assets/images/p3-12/line-bottom.svg" />
      <img src="../../assets/images/p3-12/num-bottom.svg" />
    </div>
    <GoNext class="animate-target" v-animate-in href="/section3/3-13">Next</GoNext>
    <ContentNotice class="animate-target" v-animate-in :txt="noticeTxt"/>
  </div>
</template>

<script>
import SectionTitle from "../../components/SectionTitle";
import GoNext from "../../components/GoNext";
import ContentNotice from "../../components/ContentNotice";
import {mapState} from "vuex";
export default {
  name: "s3-12",
  components: {SectionTitle, GoNext, ContentNotice},
  computed:{
  },
  data(){
    return{
      noticeTxt:"*Finerenone is not indicated for the reduction of SBP.​<br/><div class='brs'></div>"
      +"eGFR, estimated glomerular filtration rate; LS, least squares; SBP, systolic blood pressure; SGLT2i, sodium-glucose cotransporter 2.<br/><div class='brs'></div>"
      +"References:<br/><div class='brs'></div>"
      +"1. Agarwal R, <i>et al. N Engl J Med</i>. 2025:1-11. doi:10.1056/NEJMoa2410659.",
      title:"<div class='h-image'><img class='title-logo' src='"+require('../../assets/images/p3-title-icon.png')+"' /><p>CONFIDENCE investigated the combination of finerenone and SGLT2i in chronic kidney disease and type 2 diabetes<sup>1</sup></p></div>"
    }
  },

  mounted() {
    this.initClassObserver(); // 组件挂载后初始化监听
  },
  beforeDestroy() {
    this.destroyObserver(); // 组件卸载前销毁监听
  },
  methods: {

    initClassObserver() {
      const targetEl = this.$refs.target;
      const targetEl2 = this.$refs.target2;
      if (!targetEl) return;

      this.observer = new MutationObserver((mutations) => {
        console.log(mutations[0].target.children[1]);
        const mutation = mutations[0];
        if (mutation.attributeName === 'class') {
          mutations[0].target.children[1].classList.add('extend2')
          mutations[0].target.children[2].classList.add('fadeIn')
        }
      });

      const config = {
        attributes: true,
        attributeFilter: ['class'],
        attributeOldValue: true,
      };

      this.observer.observe(targetEl, config);
      this.observer.observe(targetEl2, config);
    },

    // 销毁观察者（避免内存泄漏）
    destroyObserver() {
      if (this.observer) {
        this.observer.disconnect(); // 断开监听
        this.observer = null; // 清空实例
      }
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/section3/s3.css";
.ctn-text {
  margin-top: 40px;
}
.ctn-text2 {
  font-size: 20px;
  display: flex;
  background-color: RGB(216 216 216 / 25%);
  padding: 15px 30px;
  align-items: center;
  width:100%;
  margin-top:30px;
}
.ctn-text p {
  color: #10384F;
  font-size: 20px;
  margin-bottom: 5px;
}
.ctn-text p:nth-child(2) {
  font-weight: bold;
  font-size: 24px;
}
.ctn-image {
  width: 100%;
  margin-top: 30px;
}
.show_animation {
  position:relative;
  width: 100%;
  margin-top: 30px;
}
.show_animation img {
  width: 100%;
}
.show_animation img:nth-child(2) {
  position:absolute;
  height: 100%;
  bottom:0px;
  left:0px;
  width:0%;
  object-fit: cover;
  object-position: left;
}
.show_animation img:nth-child(3) {
  position:absolute;
  width: 100%;
  bottom:0px;
  left:0px;
  object-fit: cover;
  object-position: bottom;
  opacity: 0;
}
</style>
